export type SetToastFunc = (toast: IToast) => void;

export interface IToast {
	content: string;
	severity: ToastSeverity;
	id?: string;
	error?: unknown;
}

export enum ToastSeverity {
	Info = 'info',
	Warning = 'warning',
	Error = 'error',
	Success = 'success'
}
